import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import { get_branchstock } from "../../services/projectApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker";
const BranchStock = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const user_branch = user?.employee?.branch_id;
  const queryClient = useQueryClient();
  const getJobQuery = useQuery(["get_branch_stock"], () =>
    get_branchstock(user_branch)
  );
  const branchStock = useMemo(() => {
    return getJobQuery.data || [];
  }, [getJobQuery.data]);
  if (getJobQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (getJobQuery.isError) {
    return <div>Error: {getJobQuery.error.message}</div>;
  }

  const BranchStockColumn = [
    {
      header: "item",
      accessorKey: "item_name",
    },
    {
      header: "item_units",
      accessorKey: "item_units",
    },
    {
      header: "quantity",
      accessorKey: "current_quantity",
    },
  ];

  return (
    <>
      <BasicTable
        data={branchStock.data}
        columns={BranchStockColumn}
        title={`Branch Stock`}
      />
    </>
  );
};

export default BranchStock;
